import * as React from "react";
import { Link } from "react-router-dom";
import MarketAreaSwitcher from "./MarketAreaSwitcher";
import salesInfoStore from "../../../Store/SalesInfoStore";

export default function AdminMenu() {
    const adminMenuActive = salesInfoStore((s) => s.adminMenuActive);
    const toggleAdminMenu = salesInfoStore((s) => s.toggleAdminMenu);
    const mobileOverLayClose = salesInfoStore((s) => s.mobileOverLayClose);
    const adminMenuClassName: string = `AdminMenu ${
        adminMenuActive ? "AdminMenu--active" : ""
    }`;

    return (
        <div className={adminMenuClassName}>
            <button
                onClick={() => toggleAdminMenu(false)}
                className="btn btn-primary AdminMenu__closeButton"
            >
                Close
            </button>
            <MarketAreaSwitcher />
            <Link
                onClick={() => mobileOverLayClose()}
                to={{ pathname: "/adminChangeRequests" }}
            >
                Browse change requests
            </Link>
        </div>
    );
}
